import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import styles from "./Videoplay.module.css";
import { useAddToCart } from "../../queries/useCartQuery";

// IMPORTANT:
// Change this import path according to where Videoplay.jsx is located.
// Your existing project uses useAddToCart from useCartQuery.


const videos = [
  {
    id: 1,

    // Backend product ID
    productId: 1,

    // Product detail page slug
    productSlug:
      "hardon-plus-%E2%80%93-unleash-your-full-potential!",

    src: "/vitaura1.mp4",

    productImage:
      "https://media.gettyimages.com/id/1469968739/photo/boesenbergia-rotunda-kaempferia-cochinchinensis-gagnep-kaempferia-ovata-roscoe-kaempferia.jpg?s=612x612&w=0&k=20&c=3_EZO6es6Goly2UZrp4BMSt3cnhWIAbZeDkyHI8pGjc=",

    title: "Vitaura Premium Product Combo",

    price: "₹499",
    oldPrice: "₹999",
    discount: "50% off",
  },

  {
    id: 2,

    // CHANGE THIS TO YOUR REAL PRODUCT ID
    productId: 2,

    // CHANGE THIS TO YOUR REAL PRODUCT SLUG
    productSlug: "vitaura-daily-nutrition-wellness",

    src: "/vitaura2.mp4",

    productImage:
      "https://media.gettyimages.com/id/1992899894/photo/probiotic-complex-capsules.jpg?s=612x612&w=0&k=20&c=as6YCFGE4UmWOSFZIApOfEu7IuGO5CCS6j3I7zYppkA=",

    title: "Daily Nutrition & Wellness Combo",

    price: "₹599",
    oldPrice: "₹1,199",
    discount: "50% off",
  },

  {
    id: 3,

    // CHANGE THIS TO YOUR REAL PRODUCT ID
    productId: 3,

    // CHANGE THIS TO YOUR REAL PRODUCT SLUG
    productSlug: "vitaura-premium-health-wellness",

    src: "/vitaura5.mp4",

    productImage:
      "https://media.gettyimages.com/id/1299764992/photo/kooreegusu-chili-pepper-pickled-in-awamori-okinawa-prefecture-japan.jpg?s=612x612&w=0&k=20&c=h0VvUKG6jzKzbNzgE9Bz3Fkygijoz7OdpvQ-BvePMEA=",

    title: "Premium Health & Wellness Pack",

    price: "₹499",
    oldPrice: "₹1,099",
    discount: "55% off",
  },

  {
    id: 4,

    // CHANGE THIS TO YOUR REAL PRODUCT ID
    productId: 4,

    // CHANGE THIS TO YOUR REAL PRODUCT SLUG
    productSlug: "vitaura-complete-health-nutrition",

    src: "/vitaura4.mp4",

    productImage:
      "https://media.gettyimages.com/id/1420549110/photo/plastic-package-product.jpg?s=612x612&w=0&k=20&c=TBsE5xQt5w6F7a6rWBYcf5np4iq5FCT5DJozJTah9CM=",

    title: "Complete Health Nutrition Pack",

    price: "₹699",
    oldPrice: "₹1,299",
    discount: "46% off",
  },
];

const AutoPlayVideoSlider = () => {
  const navigate = useNavigate();

  const videoRefs = useRef([]);
  const popupVideoRef = useRef(null);

  const [activeVideo, setActiveVideo] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

 
  const { mutate: addToCart, isPending: isAddingToCart } = useAddToCart();

 
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.6,
      },
    );

    videoRefs.current.forEach((video) => {
      if (video) {
        observer.observe(video);
      }
    });

    return () => {
      videoRefs.current.forEach((video) => {
        if (video) {
          observer.unobserve(video);
        }
      });
    };
  }, []);


  const openVideoPopup = (item, index) => {
    const cardVideo = videoRefs.current[index];

    if (cardVideo) {
      cardVideo.pause();
    }

    setActiveVideo(null);

    setSelectedVideo(item);
  };

  
  const closeVideoPopup = () => {
    if (popupVideoRef.current) {
      popupVideoRef.current.pause();
      popupVideoRef.current.currentTime = 0;
    }

    setSelectedVideo(null);
  };

  
  useEffect(() => {
    if (!selectedVideo) return;

    document.body.style.overflow = "hidden";

    const timer = setTimeout(() => {
      const video = popupVideoRef.current;

      if (!video) return;

      // First try muted autoplay
      video.muted = true;

      video
        .play()
        .then(() => {
          // Try to enable sound after autoplay starts
          video.muted = false;
        })
        .catch(() => {
          video.muted = true;

          video.play().catch(() => {});
        });
    }, 150);

    return () => {
      clearTimeout(timer);

      document.body.style.overflow = "";

      if (popupVideoRef.current) {
        popupVideoRef.current.pause();
      }
    };
  }, [selectedVideo]);

  
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        closeVideoPopup();
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

 

const handleSoundClick = (event, index) => {
  event.stopPropagation();

  const clickedVideo = videoRefs.current[index];

  if (!clickedVideo) return;


  if (clickedVideo.muted) {
    videoRefs.current.forEach((video, videoIndex) => {
      if (!video) return;

      if (videoIndex === index) {
        // Turn ON sound for clicked video
        video.muted = false;
        video.volume = 1;
      } else {
        // Turn OFF sound for all other videos
        video.muted = true;
      }
    });

    setActiveVideo(index);

    clickedVideo.play().catch(() => {});
  } else {
    // Turn OFF sound for clicked video
    clickedVideo.muted = true;

    setActiveVideo(null);
  }
};



 
  const handleMoreInfo = () => {
    if (!selectedVideo?.productSlug) return;

    closeVideoPopup();

    navigate(`/productdetails/${selectedVideo.productSlug}`);
  };

  
  const handleAddToCart = () => {
    if (!selectedVideo?.productId) {
      toast.error("Product information is missing");
      return;
    }

    addToCart(
      {
        product_id: selectedVideo.productId,
        quantity: 1,
      },
      {
        onSuccess: () => {
          toast.success("Product added to cart");
        },

        onError: (error) => {
          console.error("Add to cart error:", error);

          toast.error(
            error?.response?.data?.message ||
              error?.message ||
              "Unable to add product to cart",
          );
        },
      },
    );
  };

  /*
  =========================================================
  RENDER
  =========================================================
  */
  return (
    <>
      {/* =====================================================
          VIDEO SLIDER
      ===================================================== */}
      <section className={styles.videoSection}>
        <div className={styles.videoContainer}>
          {videos.map((item, index) => (
            <div
              className={styles.productCard}
              key={item.id}
              onClick={() => openVideoPopup(item, index)}
            >
              {/* VIDEO */}
              <div className={styles.videoWrapper}>
                <video
                  ref={(el) => {
                    videoRefs.current[index] = el;
                  }}
                  className={styles.video}
                  src={item.src}
                  muted
                  loop
                  playsInline
                  preload="metadata"
                />

                {/* SOUND BUTTON */}
                <button
                  type="button"
                  className={styles.soundButton}
                  onClick={(event) =>
                    handleSoundClick(event, index)
                  }
                  aria-label="Toggle sound"
                >
                  {activeVideo === index ? "🔊" : "🔇"}
                </button>

                {/* PRODUCT THUMBNAIL */}
                <div className={styles.productThumb}>
                  <img
                    src={item.productImage}
                    alt={item.title}
                    onError={(event) => {
                      event.currentTarget.style.display = "none";
                    }}
                  />
                </div>

                {/* PLAY OVERLAY */}
                <div className={styles.playOverlay}>
                  <span className={styles.playIcon}>▶</span>
                </div>
              </div>

              {/* PRODUCT INFO */}
              <div className={styles.productInfo}>
                <h3 title={item.title}>{item.title}</h3>

                <div className={styles.priceRow}>
                  <span className={styles.price}>
                    {item.price}
                  </span>

                  <span className={styles.oldPrice}>
                    {item.oldPrice}
                  </span>

                  <span className={styles.discount}>
                    {item.discount}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* =====================================================
          VIDEO POPUP
      ===================================================== */}
      {selectedVideo && (
        <div
          className={styles.videoModal}
          onClick={closeVideoPopup}
        >
          <div
            className={styles.videoModalContent}
            onClick={(event) => event.stopPropagation()}
          >
            {/* CLOSE */}
            <button
              type="button"
              className={styles.closeButton}
              onClick={closeVideoPopup}
              aria-label="Close video"
            >
              ×
            </button>

            {/* =================================================
                POPUP VIDEO
            ================================================= */}
            <div className={styles.popupVideoWrapper}>
              <video
                ref={popupVideoRef}
                className={styles.popupVideo}
                src={selectedVideo.src}
                controls
                autoPlay
                playsInline
                loop
              />
            </div>

            {/* =================================================
                PRODUCT DETAILS
            ================================================= */}
            <div className={styles.popupProductInfo}>
              {/* PRODUCT IMAGE */}
              <div className={styles.popupProductImage}>
                <img
                  src={selectedVideo.productImage}
                  alt={selectedVideo.title}
                />
              </div>

              {/* DETAILS */}
              <div className={styles.popupDetails}>
                <h2>{selectedVideo.title}</h2>

                <div className={styles.popupPriceRow}>
                  <span className={styles.popupPrice}>
                    {selectedVideo.price}
                  </span>

                  <span className={styles.popupOldPrice}>
                    {selectedVideo.oldPrice}
                  </span>

                  <span className={styles.popupDiscount}>
                    {selectedVideo.discount}
                  </span>
                </div>
              </div>
            </div>

            {/* =================================================
                ACTION BUTTONS
            ================================================= */}
            <div className={styles.popupActions}>
            <button
  type="button"
  className={styles.moreInfoButton}
  disabled
  // onClick={handleMoreInfo}
>
  More Info
</button>

             <button
  className={styles.addToCartButton}
  onClick={handleAddToCart}
  disabled={true}
>
  Add to Cart
</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AutoPlayVideoSlider;